import { OnSelectionChangedFn } from "@wix/design-system";
import { useState, useCallback } from "react";

export const useTableItemSelection = ({ pageNumber, itemLists }: { pageNumber: number; itemLists: any }) => {
  const [selectedItem, setSelectedItem] = useState<{ [key: number]: number[] | undefined }>({});

  const setEmptySelectionItem = useCallback(() => setSelectedItem({ 1: [] }), []);

  const setItemSelection: OnSelectionChangedFn = useCallback(
    (selectedIds, change): void => {
      const itemsInCurrentPage = selectedItem[pageNumber];
      const isItemsEmpty = itemsInCurrentPage === undefined || itemsInCurrentPage?.length === 0;

      setSelectedItem({
        ...selectedItem,
        [`${pageNumber}`]:
          isItemsEmpty || change
            ? selectedIds?.filter((p) => itemLists?.map(({ id }: { id: number }) => id).includes(p))
            : itemsInCurrentPage,
      });
    },
    [pageNumber, itemLists]
  );

  return {
    setSelectedItem,
    selectedItem,
    setItemSelection,
    setEmptySelectionItem,
    selectedItemsCount: Object.values(selectedItem).flat().length,
  };
};
